import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { t } from 'utils/translates';

import ListItemLink from 'components/Common/ListItemLink/ListItemLink';
import { getItemFromRefList } from 'mt-react-common/modules/main/reducers/static/states/referenceLists/reducer';
import { withRouter } from 'react-router-dom';

import createTopUsersContainer from 'components/TopUsers/_common/TopUsersContainer';
import { getTopListsMap } from 'components/TopUsers/_common/topListsMap';

// eslint-disable-next-line react/prefer-stateless-function
const TopUsers = props => {
  const [topListItem] = useState(getTopListsMap()[props.match.params.topList]);
  const [TopListComponent] = useState(
    createTopUsersContainer(topListItem.component)
  );

  return (
    <div className="panel panel-default panel-heading_padding-large">
      <div className="panel-heading">
        <h1 className="panel-title">
          <i className={`${topListItem.iconClass}`} /> {t('Топ пользователей')}{' '}
          - {topListItem.name}
        </h1>
      </div>
      <div className="panel-bar">
        <ul className="nav nav-tabs nav-tabs-lg">
          {Object.keys(props.topUsersGroupTypes).map(key => {
            const name = props.topUsersGroupTypes[key];
            return (
              <ListItemLink
                key={`top-users-${key}`}
                to={{
                  pathname: `/users/top-users/${props.match.params.topList}/${key}`
                }}
              >
                {name}
              </ListItemLink>
            );
          })}
        </ul>
      </div>
      <div className="panel-body">
        <div className="tab-content">
          <TopListComponent {...props} reducerName={topListItem.reducerName} />
        </div>
      </div>
    </div>
  );
};

TopUsers.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      topList: PropTypes.string,
      group: PropTypes.string
    }).isRequired
  }).isRequired,

  // CONNECT STATES
  topUsersGroupTypes: PropTypes.shape({}).isRequired
};

const mapStateToProps = state => ({
  topUsersGroupTypes: getItemFromRefList(state, 'topUsersGroupTypes')
});

export default withRouter(connect(mapStateToProps)(TopUsers));



// WEBPACK FOOTER //
// ./src/components/TopUsers/TopUsers.js